/* @remove-on-es-build-begin */
const ENV = process.env.NODE_ENV;
if (ENV !== 'production' &&
    ENV !== 'test' &&
    typeof console !== 'undefined' &&
    console.warn &&
    typeof window !== 'undefined') {
  console.warn(
    'You are using a whole package of antd, ' +
    'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.',
  );
}
/* @remove-on-es-build-end */

export { default as View } from './view';

export { default as ImageGallery } from './image-gallery';

export { default as version } from './version';


// WEBPACK FOOTER //
// ./components/index.tsx